import MyToolsFooterButton from './MyToolsFooterButton';

export default MyToolsFooterButton;